import Styles from "./BasicContactInfo.module.scss";

import { ReactComponent as CallIcon } from "../../../../icons/extra_icons/call.svg"
import { ReactComponent as MessageIcon } from "../../../../icons/extra_icons/message.svg"
import { ReactComponent as VideoIcon } from "../../../../icons/extra_icons/video.svg"
import { ReactComponent as MailIcon } from "../../../../icons/extra_icons/mail.svg"
import { APP_KEY_IDS } from "../../../../constants/constants";
import { openWindow } from "../../../../actions";
import { useDispatch } from "react-redux";


interface BasicContactInfoProps {
    label: string;
    phone: string;
    work: string;
    facetime: string;
    birthday: string;
    home: string;
    pfp: string;
    designation: string
}

const BasicContactInfo = ({
    label,
    phone,
    work,
    facetime,
    birthday,
    home,
    pfp,
    designation }: BasicContactInfoProps) => {


    const dispatch = useDispatch()

    const contactPlaforms = [
        
        {
            id: 0,
            label: "call",
            icon: <CallIcon />,
            backgroundColor:"#17a664",
            onClick: () => { }
        },
        {
            id: 1,
            label: "message",
            icon: <MessageIcon />,
            backgroundColor:"#27a9f5",
            onClick: () => { dispatch(openWindow(APP_KEY_IDS.MOBILE_CONTACTS)) }
        },
        {
            id: 2,
            label: "video",
            icon: <VideoIcon />,
            backgroundColor:"#17a664",
            onClick: () => { }
        },
    ]


    return (
        <div className={Styles.container}>
            <div className={Styles.top_half}>
                <div className={Styles.container}>
                    <div className={Styles.pfp}>
                    <img src={pfp || "https://firebasestorage.googleapis.com/v0/b/priyanshdatyal-me.appspot.com/o/website%20resources%2Fportfolio_profile_picture.webp?alt=media&token=8396fd2a-7b6e-452d-866b-b0aecf5077f0"} />
                    </div>
                    <div className={Styles.name}>
                        {label}
                    </div>
                    <div className={Styles.number}>
                        <span className={Styles.label}>Mobile</span>
                        <span>{phone.slice(5)}</span>
                    </div>
                    <div className={Styles.options_container}>
                        {
                            contactPlaforms.map((platform: any) => {
                                return (
                                    <div className={Styles.platform} key={platform.id}>
                                        <div className={Styles.icon} style={{backgroundColor:`${platform.backgroundColor}`}}>
                                        {platform.icon}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            <div className={Styles.bottom_half}>
                <div className={Styles.details}>
                    <div className={Styles.info_text}>
                        <div className={Styles.key}>work</div>
                        <div className={Styles.value}>{work}</div>
                    </div>
                    <div className={Styles.info_text}>
                        <div className={Styles.key}>work</div>
                        <div className={Styles.value}>{work}</div>
                    </div>
                    <div className={Styles.divider} />
                    <div className={Styles.info_text}>
                        <div className={Styles.key}>birthday</div>
                        <div className={Styles.value}>{birthday}</div>
                    </div>
                    <div className={Styles.divider} />
                    <div className={Styles.info_text}>
                        <div className={Styles.key}>home</div>
                        <div className={Styles.value}>{home}</div>
                    </div>
                </div>
                <div className={Styles.buttons}>
                    <div className={Styles.button} onClick={()=>{dispatch(openWindow(APP_KEY_IDS.FEEDBACK))}} >Feedback</div>
                    <div className={Styles.button} onClick={()=>{dispatch(openWindow(APP_KEY_IDS.HIRE))}} >Hire</div>
                </div>
                <div className={Styles.history_container}>
                    <div className={Styles.history}>History</div>
                </div>


            </div>
        </div>
    )
}

export default BasicContactInfo
